<!-- =============================================================================
     Notification Dropdown Component Template
     src/app/shared/components/notification-dropdown/notification-dropdown.component.html
     ============================================================================= -->

<!-- Notification Bell Button with Badge -->
<button
  mat-icon-button
  [matMenuTriggerFor]="notificationMenu"
  class="notification-trigger"
  matTooltip="الإشعارات"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
>
  <mat-icon>notifications</mat-icon>
  <!-- Custom Badge -->
  @if (hasUnread()) {
    <span class="custom-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
  }
</button>

<!-- Notification Dropdown Menu -->
<mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before">
  <!-- Menu Header -->
  <div class="menu-header" (click)="$event.stopPropagation()">
    <div class="header-title">
      <mat-icon>notifications</mat-icon>
      <h3>الإشعارات</h3>
      @if (hasUnread()) {
        <span class="unread-badge">{{ unreadCount() }}</span>
      }
    </div>
    <div class="header-actions">
      @if (hasUnread()) {
        <button
          mat-icon-button
          matTooltip="تحديد الكل كمقروء"
          (click)="onMarkAllAsRead($event)"
          [disabled]="markingAllRead()"
          class="mark-all-btn"
        >
          @if (markingAllRead()) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon>done_all</mat-icon>
          }
        </button>
      }
      <button
        mat-icon-button
        matTooltip="تحديث"
        (click)="onRefresh($event)"
        class="refresh-btn"
      >
        <mat-icon [class.spinning]="loading()">refresh</mat-icon>
      </button>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Notifications List -->
  <div class="notifications-list">
    @if (loading() && recentNotifications().length === 0) {
      <!-- Loading State -->
      <div class="loading-state">
        <mat-spinner diameter="32"></mat-spinner>
        <span>جاري تحميل الإشعارات...</span>
      </div>
    } @else if (recentNotifications().length === 0) {
      <!-- Empty State -->
      <div class="empty-state">
        <mat-icon>notifications_none</mat-icon>
        <p>لا توجد إشعارات</p>
      </div>
    } @else {
      <!-- Notifications -->
      @for (notification of recentNotifications(); track trackByNotificationId($index, notification)) {
        <button
          mat-menu-item
          class="notification-item"
          [class.unread]="!notification.isRead"
          (click)="onNotificationClick(notification)"
          matRipple
        >
          <!-- Notification Icon -->
          <div class="notification-icon" [ngClass]="'icon-' + getNotificationColor(notification.notificationType)">
            <mat-icon>{{ getNotificationIcon(notification.notificationType) }}</mat-icon>
          </div>

          <!-- Notification Content -->
          <div class="notification-content">
            <p class="notification-title">{{ notification.title }}</p>
            <span class="notification-time">
              <mat-icon>schedule</mat-icon>
              {{ notification.timeAgo }}
            </span>
          </div>

          <!-- Unread Indicator -->
          @if (!notification.isRead) {
            <div class="unread-indicator"></div>
          }
        </button>
      }
    }
  </div>

  <mat-divider></mat-divider>

  <!-- View All Button -->
  <div class="menu-footer">
    <button mat-button color="primary" class="view-all-btn" (click)="onViewAllClick()">
      <mat-icon>list</mat-icon>
      <span>مشاهدة الكل</span>
    </button>
  </div>
</mat-menu>
